/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_dRhJRuo9y",
    "aws_user_pools_web_client_id": "kr16cpo39pffarbbjp9683tvb",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://4napg5ott1.execute-api.eu-west-1.amazonaws.com/production}",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://vjsdsbpu6nd4dkjjavwvkokdxu.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": ""
};

export default awsmobile;
